import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import ArticleCard from "../components/ArticleCard";
import InkWallsGallery from "../components/InkWallsGallery";
import Reveal from "../components/Reveal";
import { categoryLabel } from "../lib/categories";

export default function CategoryPage() {
  const { slug } = useParams();
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    setArticles(null);
    api.get("/articles", { params: { category: slug } })
      .then((r) => setArticles(r.data))
      .catch(() => setArticles([]));
  }, [slug]);

  return (
    <div data-testid="category-page" className="max-w-[1440px] mx-auto px-5 lg:px-10 py-16 lg:py-24">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-kinetic mb-4">Section</p>
        <h1 className="font-display font-black uppercase text-4xl sm:text-6xl lg:text-7xl tracking-tight break-words">
          {categoryLabel(slug)}
        </h1>
        {articles && (
          <p className="text-ash font-mono text-xs uppercase tracking-[0.2em] mt-4">
            {articles.length} {articles.length === 1 ? "story" : "stories"}
          </p>
        )}
      </Reveal>

      {slug === "ink-street" && <InkWallsGallery />}

      {!articles ? (
        <p className="font-mono text-ash text-xs uppercase tracking-[0.3em] py-24 text-center animate-pulse">Loading…</p>
      ) : articles.length === 0 ? (
        <p className="font-mono text-ash text-xs uppercase tracking-[0.3em] py-24 text-center">Nothing filed here yet — the desk is working on it.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {articles.map((a, i) => (
            <ArticleCard key={a.id} article={a} index={i} large={i % 7 === 0} />
          ))}
        </div>
      )}
    </div>
  );
}
